const headerBg   = 'https://download4.qcplay.com/h5-images/active/mitu/drainage/head/header_bg.png';
const headerBg2  = 'https://download4.qcplay.com/h5-images/active/mitu/drainage/head/header_bg2.png';
const loginBtn   = 'https://download4.qcplay.com/h5-images/active/mitu/drainage/head/login.png';
const accountBtn = 'https://download4.qcplay.com/h5-images/active/mitu/drainage/head/btn_07.png';
const logoutBtn  = 'https://download4.qcplay.com/h5-images/active/mitu/drainage/head/logoutBtn.png';

export const headerConfig = {
    not_logged_in: {
        background_image: headerBg,
        style: 'height:104px'
    },
    logged_in: {
        background_image: headerBg2,
        main_title_color: '#0a1f27',
        sub_title_color: '#0a1f27',
        tips_color: '#0a1f27',
        game_name: '骑士冲呀'
    },
    operation_btn: {
        office_website: {
            width: '',
            height: '',
            background_image: '',
            img: '',
            style: 'display:none;',
            link: ''
        },
        login: {
            width: '',
            height: '',
            background_image: '',
            img: loginBtn,
            style: 'top: 0.35rem;right: 0.27rem;',
        },
        change_account: {
            width: '',
            height: '',
            background_image: '',
            img: accountBtn,
            style: 'top: 0.25rem'
        },
        join_active: {
            width: '',
            height: '',
            background_image: '',
            img: '',
            style: 'display:none',
            link: ''
        },
        logout: {
            width: '',
            height: '',
            img: logoutBtn,
            style: 'top: 0.25rem'
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/mitu/drainage/headerConfig.js